export const enum DocumentVersionStatus {
  archived = "archived",
  draft = "draft",
  published = "published",
}

export enum UserStatus {
  active = "active",
  deactivated = "deactivated",
  pending = "pending",
  deleted = "deleted",
}

export interface TQRcode {
  secret: string;
  otpauthUrl: string;
}
export interface TCreateTier {
  title: string;
  description?: string;
  parentId: number | null;
}

export interface TUpdateTier {
  title?: string;
  description?: string;
}

export const reviewPeriod = ["3 MONTH", "6 MONTH", "1 YEAR"] as const;
export type ReviewPeriod = (typeof reviewPeriod)[number];

export enum PlatformRole {
  contributor = "contributor",
  coordinator = "coordinator",
  superAdmin = "superadmin",
  reader = "reader",
}

export function getRoleLabels(
  t: (key: string) => string,
): Record<PlatformRole, string> {
  return {
    [PlatformRole.superAdmin]: t("commons.roles.superadmin"),
    [PlatformRole.coordinator]: t("commons.roles.coordinator"),
    [PlatformRole.contributor]: t("commons.roles.contributor"),
    [PlatformRole.reader]: t("commons.roles.reader"),
  };
}
